export default {"src":"/uk/_next/static/media/accountIcon.f3def252.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};